import { IGraphqlMapper } from '../../models/interfaces/I-graphql-mapper';
import { IGraphqlExportMapper } from '../../models/interfaces/i-graphql-export-mapper';
import { UserModel } from '../../models/interfaces/user.model';
import { UserTypeModel } from '../../technicians/models/technician.model';

export class InsertUserMapper implements IGraphqlMapper {
  user?: UserModel;

  returnFromJson(json: any): UserModel {
    const value = json['insertUser'];
    this.user = {
      userId: value['id'],
      email: value['email'],
      companies: value['companies'],
      idpIdentifier: value['idpIdentifier'],
      name: value['name'],
      surname: value['surname'],
      userTypes: {} as any,
    };
    return this.user;
  }
}

export class ListUserTypesMapper implements IGraphqlExportMapper {
  elements: UserTypeModel[] = [];

  returnFromJson(json: any): UserTypeModel[] {
    this.elements = [];
    const values = json['listUserTypes'];
    values.forEach((value: any) => {
      this.elements.push({
        id: value['id'],
        name: value['name'],
        idpIdentifier: value['idpIdentifier'],
      });
    });
    return this.elements;
  }
}
